import { useState, useRef, useEffect } from "react";
import { Sparkles, X, Send, Loader2 } from "lucide-react";
import api from "../lib/api";

export function AskAngela({ open, onClose }) {
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [msgs, setMsgs] = useState([
    { role: "assistant", text: "Hi, I'm Angela — your ARQITEK AI. Ask me about a deal, feasibility, or your process." },
  ]);
  const sid = useRef(
    (() => {
      const k = "angela-sid";
      let v = sessionStorage.getItem(k);
      if (!v) { v = `angela-${Math.random().toString(36).slice(2)}`; sessionStorage.setItem(k, v); }
      return v;
    })()
  );
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, open]);

  const send = async (e) => {
    e?.preventDefault();
    const text = input.trim();
    if (!text || busy) return;
    setInput("");
    const history = msgs.slice(-12).map((m) => ({ role: m.role, content: m.text }));
    setMsgs((m) => [...m, { role: "user", text }]);
    setBusy(true);
    try {
      const r = await api.post("/ai/chat", { message: text, session_id: sid.current, history });
      setMsgs((m) => [...m, { role: "assistant", text: r.data.reply }]);
    } catch {
      setMsgs((m) => [...m, { role: "assistant", text: "Sorry — I couldn't reach the AI service. Please try again." }]);
    } finally { setBusy(false); }
  };

  if (!open) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 w-[360px] max-w-[calc(100vw-2rem)] h-[520px] max-h-[80vh] flex flex-col rounded-xl border border-border bg-card shadow-2xl" data-testid="ask-angela-panel">
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <div className="flex items-center gap-2 font-medium"><Sparkles className="h-4 w-4 text-primary" /> Angela</div>
        <button onClick={onClose} data-testid="ask-angela-close" className="p-1 rounded hover:bg-accent"><X className="h-4 w-4" /></button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {msgs.map((m, i) => (
          <div key={i} className={m.role === "user" ? "text-right" : "text-left"}>
            <span className={`inline-block rounded-lg px-3 py-2 text-sm whitespace-pre-wrap max-w-[85%] ${m.role === "user" ? "bg-primary text-primary-foreground" : "bg-secondary text-foreground"}`}>{m.text}</span>
          </div>
        ))}
        {busy && <div className="text-left"><span className="inline-flex items-center gap-2 rounded-lg bg-secondary px-3 py-2 text-sm text-muted-foreground"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Thinking…</span></div>}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="p-3 border-t border-border flex gap-2">
        <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask Angela…" data-testid="ask-angela-input"
          className="flex-1 rounded-md border border-border bg-background px-3 py-2 text-sm outline-none focus:border-primary" />
        <button type="submit" disabled={busy || !input.trim()} data-testid="ask-angela-send"
          className="rounded-md bg-primary text-primary-foreground px-3 disabled:opacity-50"><Send className="h-4 w-4" /></button>
      </form>
    </div>
  );
}
